import { render, staticRenderFns } from "./SoundController.vue?vue&type=template&id=18962e5e&scoped=true&"
import script from "./SoundController.vue?vue&type=script&lang=js&"
export * from "./SoundController.vue?vue&type=script&lang=js&"
import style0 from "./SoundController.vue?vue&type=style&index=0&id=18962e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18962e5e",
  null
  
)

export default component.exports